import {
    ADD_FOLDER,
    ADD_FOLDER_FAILURE,
    ADD_FOLDER_REQUEST,
    ADD_LINK, CLOSE_DETAIL_PANE,
    DELETE_FOLDER,
    DELETE_LINK,
    FETCH_ALL_DATA_SUCCESS,
    FETCH_DATA_FAILURE,
    FETCH_DATA_SUCCESS, FETCH_WITH_ARCHIVE_STATUS,
    FETCH_CHILD_REQUEST,
    FOLDER_ASSIGNEE_SUCCESS, LINK_ASSIGNEE_SUCCESS, OPEN_DETAIL_PANE,
    RENAME_FOLDER_FAILURE,
    RENAME_FOLDER_SUCCESS, UPDATE_ARCHIVE_STATUS,
    UPDATE_LINK_SUCCESS, UPDATE_ITEM_STAR_LEVEL,
    SET_SORT_BY_STATUS,
} from "../constants/folders.constant";
import Cookies from "js-cookie";
import axios from "axios";
import toast from "react-hot-toast";
import { BACKEND_API_URL } from "../../utils/api";

const REACT_APP_BACKEND_API_URL = BACKEND_API_URL;
export const fetchDataSuccess = (folders, depth, isArchiveChanged=false) => ({
    type: FETCH_DATA_SUCCESS,
    payload: {
        folders,
        depth,
        isArchiveChanged
    },
});

export const fetchWithArchiveStatus = (folders, depth) => ({
    type: FETCH_WITH_ARCHIVE_STATUS,
    payload: { folders, depth }
});

export const fetchAllDataSuccess = (data) => ({
    type: FETCH_ALL_DATA_SUCCESS,
    payload: {
        data
    },
});

export const fetchAllDataRequest = (requestId) => ({
    type: 'FETCH_ALL_DATA_REQUEST',
    payload: { requestId }
});

export const fetchChildDataSuccess = (folders, depth, folder_id) => ({
    type: FETCH_DATA_SUCCESS,
    payload: {
        folders,
        depth,
        folder_id: folder_id,
        // requestId may be included when dispatched from an async fetch
        requestId: null,
        child: true,

    },
});

export const fetchDataFailure = (error) => ({
    type: FETCH_DATA_FAILURE,
    payload: error,
});


export const addFolder = (folderName, depth, parent_folder_id, navigate) => {
    return async (dispatch) => {
        dispatch({type: ADD_FOLDER_REQUEST});

        // Generate a unique creation token to securely identify this folder
        const creationToken = `create_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

        try {
            const accessToken = Cookies.get('access_token');
            let url;
            if (parent_folder_id) {
                url = `${REACT_APP_BACKEND_API_URL}/api/folder/create/${parent_folder_id}`
            } else {
                url = `${REACT_APP_BACKEND_API_URL}/api/folder/create/`
            }

            const response = await axios.post(url, {name: folderName},
                {
                    headers: {
                        'Authorization': `Token ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
            toast.success('Folder Created Successfully');

            const data = response.data;

            // Add folder to state with creation token for secure identification
            dispatch({
                type: ADD_FOLDER,
                payload: {
                    data: { ...data, _creationToken: creationToken },
                    depth
                },
            });

            // Navigate to the newly created folder
            if (navigate && data.id) {
                // Get archive status - if viewing archived only, switch to excludeArchive
                // so the new folder (non-archived by default) is visible
                let archiveStatus = Cookies.get('archiveStatus');
                if (archiveStatus === 'onlyArchive') {
                    archiveStatus = 'excludeArchive';
                    Cookies.set('archiveStatus', archiveStatus);
                    // Note: Archive status is managed by Zustand store, cookie is updated for persistence
                    toast.success('Switched to non-archived view to show new folder');
                }
                
                // IMPORTANT: Await fetchChildFolders to complete before navigating
                // This ensures selected_folders is updated correctly before the
                // Home component tries to focus on the new folder
                await dispatch(fetchChildFolders(data.id, depth, archiveStatus));
                
                // Navigate with the folder ID AND creation token for secure identification
                navigate(`/folder/${data.id}?created=${creationToken}`);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Failed to create folder';
            toast.error(errorMessage);

            dispatch({
                type: ADD_FOLDER_FAILURE,
                payload: errorMessage,
            });
        }
    };
};


export const addLink = (link, name, depth, folder_id) => {
    return async (dispatch) => {

        try {
            const accessToken = Cookies.get('access_token');
            let url;
            if (folder_id) {
                url = `${REACT_APP_BACKEND_API_URL}/api/link/create/${folder_id}`
            } else {
                url = `${REACT_APP_BACKEND_API_URL}/api/link/create/`
            }

            const response = await axios.post(url, {link: link, name: name},
                {
                    headers: {
                        'Authorization': `Token ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                });
            toast.success('Link Saved Successfully');

            const data = response.data;

            dispatch({
                type: ADD_LINK,
                payload: {
                    data,
                    depth
                },
            });
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Failed to create link';
            toast.error(errorMessage);

            dispatch({
                type: ADD_FOLDER_FAILURE,
                payload: errorMessage,
            });
        }
    };
};


export const fetchFolders = (isChangeArchive=false) => {
    const archiveStatus = Cookies.get('archiveStatus');
    return async (dispatch, getState) => {
        try {
            const accessToken = Cookies.get('access_token');

            let url = `${REACT_APP_BACKEND_API_URL}/api/folders/`;
            if (archiveStatus !== null && archiveStatus !== undefined) {
                url = url + `?archive_status=${archiveStatus}`;
            }
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Token ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            const folders = await response.data;
            if (!isChangeArchive) {
                dispatch(fetchDataSuccess(folders, 1));
            } else {
                dispatch(fetchWithArchiveStatus(folders, 1));
            }
        } catch (error) {
            dispatch(fetchDataFailure(error)); // Dispatch failure action with error
        }
    };
};

export const fetchAllFolderdetails = (folderId) => {
    const archiveStatus = Cookies.get('archiveStatus');
    return async (dispatch, getState) => {
        const requestId = Date.now();
        dispatch(fetchAllDataRequest(requestId));
        try {
            const accessToken = Cookies.get('access_token');
            let url = `${REACT_APP_BACKEND_API_URL}/api/folder/structure/${folderId}`
            if (archiveStatus !== null && archiveStatus !== undefined) {
                url = url + `?archive_status=${archiveStatus}`;
            }
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Token ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.data;
            dispatch({ type: FETCH_ALL_DATA_SUCCESS, payload: { data, requestId } });
        } catch (error) {
            dispatch(fetchDataFailure(error)); // Dispatch failure action with error
        }
    };
};


export const fetchChildFolders = (folder_id, depth, archiveStatus= null) => {
    return async (dispatch, getState) => {
        // Create a request id to track latest fetch for this depth
        const requestId = Date.now();
        // Inform reducer that a fetch started for this depth
        dispatch({ type: FETCH_CHILD_REQUEST, payload: { depth: depth + 1, requestId } });
        try {
            const accessToken = Cookies.get('access_token');
            let url = `${REACT_APP_BACKEND_API_URL}/api/folders/${folder_id}/`
            if (archiveStatus !== null && archiveStatus !== undefined) {
                url = url + `?archive_status=${archiveStatus}`;
            }

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Token ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            const folders = await response.data;
            // Dispatch success action and include requestId so reducer can ignore stale responses
            dispatch({
                type: FETCH_DATA_SUCCESS,
                payload: {
                    folders,
                    depth: depth + 1,
                    folder_id: folder_id,
                    requestId,
                    child: true,
                }
            });
            // Return success to allow awaiting
            return { success: true, folder_id };
        } catch (error) {
            dispatch(fetchDataFailure(error)); // Dispatch failure action with error
            // Return failure to allow awaiting
            return { success: false, error };
        }
    };
};

export const renameFolderSuccess = (folder, depth) => ({
    type: RENAME_FOLDER_SUCCESS,
    payload: {folder, depth}
});

export const updateArchiveStatus = (status) => ({
    type: UPDATE_ARCHIVE_STATUS,
    payload: {status}
})

export const updateLinkSuccess = (link, depth) => ({
    type: UPDATE_LINK_SUCCESS,
    payload: {link, depth}
});

export const renameFolderFailure = (error) => ({
    type: RENAME_FOLDER_FAILURE,
    payload: error
});

export const deleteLinkSuccess = (link_id, depth) => ({
    type: DELETE_LINK,
    payload: {
        link_id,
        depth
    }
})

export const deleteFolderSuccess = (folder_id, depth) => ({
    type: DELETE_FOLDER,
    payload: {
        folder_id,
        depth
    }
})

export const updateLinkAssignee = (id, onSelectAssignee, linkData, isDelete = false) => {
    return async (dispatch, getState) => {
        try {
            const accessToken = Cookies.get('access_token');
            const response = await axios.post(
                `${REACT_APP_BACKEND_API_URL}/api/link/update_assignee/${linkData.link.id}`,
                {
                    assignee: id,
                    is_delete: isDelete
                },
                {
                    headers: {
                        Authorization: `Token ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (id === null) {
                toast.success('Unassigned Link')
                onSelectAssignee(null, response.data.comment);
            } else {
                onSelectAssignee(response.data.link?.employees, response.data.comment);
                const notifyStatus = response.data.notification_queued ? ' (Notifying assignee)' : '';
                toast.success('Assignee Updated Successfully' + notifyStatus);
            }
        } catch (error) {
            toast.error('Error Updating Assignee');
        }
    }
}

export const updateFolderAssignee = (id, onSelectAssignee, folderData, isDelete = false) => {
    return async (dispatch) => {
        try {
            const accessToken = Cookies.get('access_token');
            const response = await axios.post(
                `${REACT_APP_BACKEND_API_URL}/api/folder/update_assignee/${folderData.folder.id}`,
                {
                    assignee: id,
                    is_delete: isDelete
                },
                {
                    headers: {
                        Authorization: `Token ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (id === null) {
                toast.success('Unassigned Folder')
                onSelectAssignee(null, response.data.comment);
            } else {
                onSelectAssignee(response.data.folder.employees, response.data.comment);
                const notifyStatus = response.data.notification_queued ? ' (Notifying assignee)' : '';
                toast.success('Assignee Updated Successfully' + notifyStatus);
            }
        } catch (error) {
            toast.error('Error Updating Assignee');
        }
    }
}

export const folderAssigneeSuccess = (folder, depth) => ({
    type: FOLDER_ASSIGNEE_SUCCESS,
    payload: {folder, depth}
});

export const linkAssigneeSuccess = (link, depth) => ({
    type: LINK_ASSIGNEE_SUCCESS,
    payload: {link, depth}
});

export const openDetailPane = (folder_id) => ({
    type: OPEN_DETAIL_PANE,
    folder_id: folder_id
});

export const closeDetailPane = () => ({
    type: OPEN_DETAIL_PANE,
    folder_id: null
});

export const setSortByStatus = (sortByStatus) => ({
    type: SET_SORT_BY_STATUS,
    payload: sortByStatus
});

// Centralized action for toggling star level
export const toggleItemStarLevel = (item, depth, itemType) => {
    return async (dispatch) => {
        try {
            const accessToken = Cookies.get('access_token');
            const response = await axios.get(
                `${REACT_APP_BACKEND_API_URL}/api/item_starred_value_change/${item.id}`,
                {
                    headers: {
                        'Authorization': `Token ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            
            const newStarLevel = response.data.star_level;
            const levelNames = {0: "Unstarred", 1: "Level 1", 2: "Level 2", 3: "Level 3"};
            toast.success(`Star level: ${levelNames[newStarLevel]}`);
            
            // Dispatch UPDATE_ITEM_STAR_LEVEL - updates value WITHOUT sorting
            const updatedItem = {...item, star_level: newStarLevel};
            dispatch({
                type: UPDATE_ITEM_STAR_LEVEL,
                payload: {
                    item: updatedItem,
                    depth: depth,
                    itemType: itemType
                }
            });
            
            return newStarLevel;
        } catch (error) {
            console.error(error);
            toast.error("Error updating star level");
            throw error;
        }
    };
};
